import * as React from 'react';
import type { SVGProps } from 'react';
const SvgKeySpace = (props: SVGProps<SVGSVGElement>) => (
    <svg xmlns="http://www.w3.org/2000/svg" width={100} height={100} fill="currentColor" viewBox="0 0 50 50" {...props}>
        <path d="M6 12c-3.302 0-6 2.698-6 6v15c0 3.302 2.698 6 6 6h38c3.302 0 6-2.698 6-6V18c0-3.302-2.698-6-6-6H6zm0 2h38c2.22 0 4 1.78 4 4v10c0 2.22-1.78 4-4 4H6c-2.22 0-4-1.78-4-4V18c0-2.22 1.78-4 4-4zM2 32.455A5.967 5.967 0 0 0 6 34h38a5.967 5.967 0 0 0 4-1.545V33c0 2.22-1.78 4-4 4H6c-2.22 0-4-1.78-4-4v-.545z" />
    </svg>
);
export default SvgKeySpace;
